module.exports = __webpack_public_path__ + "img/sunset_icon.bfe9824f.svg";